import { ArrowBindingHintOverlayUtil } from "./overlays/ArrowBindingHintOverlayUtil.mjs";
import { ArrowHintOverlayUtil } from "./overlays/ArrowHintOverlayUtil.mjs";
import { BrushOverlayUtil } from "./overlays/BrushOverlayUtil.mjs";
import { CollaboratorBrushOverlayUtil } from "./overlays/CollaboratorBrushOverlayUtil.mjs";
import { CollaboratorHintOverlayUtil } from "./overlays/CollaboratorHintOverlayUtil.mjs";
import { CollaboratorScribbleOverlayUtil } from "./overlays/CollaboratorScribbleOverlayUtil.mjs";
import { CollaboratorShapeIndicatorOverlayUtil } from "./overlays/CollaboratorShapeIndicatorOverlayUtil.mjs";
import { ScribbleOverlayUtil } from "./overlays/ScribbleOverlayUtil.mjs";
import { SelectionForegroundOverlayUtil } from "./overlays/SelectionForegroundOverlayUtil.mjs";
import { ShapeHandleOverlayUtil } from "./overlays/ShapeHandleOverlayUtil.mjs";
import { ShapeIndicatorOverlayUtil } from "./overlays/ShapeIndicatorOverlayUtil.mjs";
import { SnapIndicatorOverlayUtil } from "./overlays/SnapIndicatorOverlayUtil.mjs";
import { ZoomBrushOverlayUtil } from "./overlays/ZoomBrushOverlayUtil.mjs";
const defaultOverlayUtils = [
  ArrowBindingHintOverlayUtil,
  ArrowHintOverlayUtil,
  BrushOverlayUtil,
  CollaboratorBrushOverlayUtil,
  CollaboratorHintOverlayUtil,
  CollaboratorScribbleOverlayUtil,
  CollaboratorShapeIndicatorOverlayUtil,
  ScribbleOverlayUtil,
  SelectionForegroundOverlayUtil,
  ShapeHandleOverlayUtil,
  ShapeIndicatorOverlayUtil,
  SnapIndicatorOverlayUtil,
  ZoomBrushOverlayUtil
];
export {
  defaultOverlayUtils
};
//# sourceMappingURL=defaultOverlayUtils.mjs.map
